export const CAESAR_WORDS = [
    /*
    'CAESAR',
    'CIPHER',
    'CODEBREAKER'
    */
    'Two heads are better than one',
    'Good things come to those who wait',
    'A chain is only as strong as its weakest link',
    'A bird in the hand is worth two in the bush',
    'A picture is worth a thousand words',
    'What goes up must come down',
    'A friend in need is a friend indeed',
    'a little learning is a dangerous thing',
    'beauty is in the eye of the beholder',
    'do not put all your eggs in one basket',
    'every cloud has a silver lining',
    'give credit where credit is due',
    'home is where the heart is',
    'if at first you do not succeed try try again',
    'if you play with fire you will get burned',
    'it never rains but it pours',
    'jack of all trades master of none',
    'kill two birds with one stone',
    'let the cat out of the bag',
    'many hands make light work',
    'necessity is the mother of invention',
    // 'never judge a book by its cover',
    'one good turn deserves another',
    'out of the frying pan and into the fire',
    'put your best foot forward',
    // 'rome was not built in a day',
    'slow and steady wins the race',
    'the early bird catches the worm',
    'the apple does not fall far from the tree',
    'the pen is mightier than the sword',
    'there is safety in numbers',
    'to err is human to forgive divine',
    'truth is stranger than fiction',
    // 'two wrongs do not make a right',
    'variety is the spice of life',
    'what goes around comes around',
    'where there is a will there is a way',
    'you are never too old to learn',
    'you cannot win them all',
    'do not count your chickens',
    'every dog has its day',
    'let sleeping dogs lie',
    'look before you leap',
    'no news is good news',
    'patience is a virtue',
    'use it or lose it',
    'fortune favours the bold',
];

export const MIN_SHIFT = 0;
export const MAX_SHIFT = 25;
export const SHIFT_ROTATE_INCREMENTS = (Math.PI * 2) / 26;

export class CaesarCipherModel {
    cipherPhrase = null;
    scrambledPhrase = null;
    cipherShift = 0;
    alphabet = null;
    scrambledAlphabet = null;
    potentialAnswers = null;

    currentTestShift = 0;
}